// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "js/" + ({"152":"invite","443":"about"}[chunkId] || chunkId) + "." + {"152":"877baacb","165":"ff8a5cd8","272":"e8b53f50","443":"222d0331","880":"f25c25fc"}[chunkId] + ".js";
};